import type { Country } from "../Country.js";
import { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";

export function shouldApplyReverseCharge(
	destinationCountry: Country | "outsideEu",
	vatType: EconomicSubjectVatType,
): boolean {
	return isCountryInEuropeanUnion(destinationCountry) && vatType === EconomicSubjectVatType.EuSubject;
}
